export default __webpack_public_path__ + "static/media/rocket-mouse.12c60f75.png";